import script from "./ArchiveList.vue?vue&type=script&setup=true&lang=js"
export * from "./ArchiveList.vue?vue&type=script&setup=true&lang=js"

import "./ArchiveList.vue?vue&type=style&index=0&id=52f00716&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52f00716"]])

export default __exports__